import styled from 'styled-components';

export const DiffColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const DiffColumn = styled.section`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const DiffLabel = styled.h4`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? 'rgba(255,255,255,0.7)'};
`;

export const DiffText = styled.p`
  position: relative;
  margin: 0;
  padding: 10px 12px;
  max-height: 320px;
  overflow-y: auto;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: ${({ theme: { colors = {} } }) => colors.surfaceContainerLow ?? 'rgba(255,255,255,0.04)'};
`;

export const Removed = styled.del`
  border-radius: 3px;
  background: ${({ theme: { colors = {} } }) => colors.errorContainer ?? 'rgba(242,85,90,0.2)'};
  color: ${({ theme: { colors = {} } }) => colors.onErrorContainer ?? '#F2555A'};
`;

export const Added = styled.ins`
  border-radius: 3px;
  text-decoration: none;
  background: ${({ theme: { colors = {} } }) => colors.successContainer ?? 'rgba(76,175,80,0.2)'};
  color: ${({ theme: { colors = {} } }) => colors.onSuccessContainer ?? '#4CAF50'};
`;
